import React, { type JSX } from 'react'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { SvgLazy } from '@mobi/component-library/Assets/Svg/SvgLazy'
import { colors } from '@mobi/component-library/Foundations'
import { Breakpoint } from '@mobi/component-library/Utils/media'
import {
  AppHeaderLogoCompactStyled,
  AppHeaderLogoFullStyled,
  AppHeaderLogoLinkStyled,
} from './AppHeaderLogo.styles'

type AppHeaderLogoProps = {
  /** Breakpoint width of when compact icon is used instead. */
  compactBreakpoint: keyof typeof Breakpoint
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  style?: React.CSSProperties
}

export const AppHeaderLogo = ({
  compactBreakpoint,
  onClick,
  style,
}: AppHeaderLogoProps): JSX.Element => {
  return (
    <AppHeaderLogoLinkStyled
      id='home-page'
      href='/'
      onClick={onClick}
      aria-label='TABtouch Logo'
      style={style}
    >
      <AppHeaderLogoFullStyled compactBreakpoint={compactBreakpoint}>
        <SvgLazy width='100%' color={colors.white} name='TABtouchLogo' />
      </AppHeaderLogoFullStyled>

      <AppHeaderLogoCompactStyled compactBreakpoint={compactBreakpoint}>
        <Icon name='LogoTabtouchCompact' size='3rem' fill={colors.white} />
      </AppHeaderLogoCompactStyled>
    </AppHeaderLogoLinkStyled>
  )
}
